<script>
export default {
  name: 'ads-banner',
  props: {
    data: {
      type: Object,
      default: {
        img: null,
        title: '',
        mark: '',
        link: '#',
        btn: '',
      },
    },
  },
}
</script>

<template>
  <div v-if="data" class="t-events-block">
    <img class="t-events-block__img" loading="lazy" :src="data.img" :alt="data.title" />

    <div class="t-main-slider__mark">{{ data.mark }}</div>

    <h3 class="t-events-block__title">{{ data.title }}</h3>
    <a class="t-btn _border t-events-block__btn" v-link :href="data.link">{{ data.btn }}</a>
  </div>
</template>



// WEBPACK FOOTER //
// src/templates/pages/events/components/ads-banner/ads-banner.vue